<section
        class="h-[460px] relative -z-10 bg-amber-500 bg-cover bg-[url('/assets/image/application-process.image/brooke-cagle-RnDGGnMEOao-unsplash-2.jpeg')]">
    <div class="absolute bg-[#36348E] bg-opacity-30 w-full h-[460px] flex items-center justify-center"></div>
</section>
<div class="container px-auto relative ">
    <div class="absolute py-3 -z-10 md:py-0 top-[-50px] left-0 w-full md:w-[600px] md:top-[-100px] md:h-[200px] md:flex items-center bg-[#36348E] ps-4 sm:ps-8 lg:ps-20">
        <h1 class="text-white text-3xl sm:text-4xl md:text-5xl font-extrabold">
            Application <br class="md:block hidden"> Process
        </h1>
    </div>
</div>
<section class="md:pt-[150px] pt-5">
    <div class="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-4 items-center">
            <div class="col-span-1  md:col-span-6 p-3 lg:p-5">
                <div class="mx-auto ">
                    <picture>
                        <source
                                srcset="assets/image/application-process.image/application-process-768x512.webp"
                                media="(max-width: 600px)"
                                class="w-full h-auto">
                        <source
                                srcset="assets/image/application-process.image/application-process-1024x683.webp"
                                media="(max-width: 1200px)"
                                class="w-full h-auto">
                        <img
                                src="assets/image/application-process.image/application-process.webp"
                                class="w-full h-auto rounded-lg shadow-lg"
                                alt="Picture example with Tailwind">
                    </picture>
                </div>

            </div>
            <div class="col-span-1 md:col-span-6 text-justify px-2">
                <h2 class="font-bold my-2 text-2xl text-center lg:text-start text-gray-600">Application Process</h2>
                <p>Admission at PAI University is granted on a rolling enrollment schedule. There are no deadlines for
                    applications because we continually accept new students throughout the year. An application is
                    reviewed by the admissions committee and evaluated based on a number of specific criteria. Original
                    and official transcripts must be used for all accepted applications. Official transcripts that are
                    not in English must be accompanied by a certified English translation. An interview may be necessary
                    to complete the application process. Upon submission of an application, students will be notified
                    within 30 days as to whether or not acceptance has been granted. The university admits students
                    regardless of race, color, national origin, disability, sex, or age. PAI University reasonably
                    accommodates applicants and students with disabilities to the extent required by applicable
                    laws.</p>
            </div>
        </div>
        <div>
            <div *ngFor="let section of admissionRequirements; let  i = index">
                <h2 class="text-2xl font-bold mt-[40px] text-center text-gray-600">{{ section.heading }}</h2>
                <ul class="md:px-[80px]">
                    <li *ngFor="let item of section.items; let i = index" class="py-[30px] w-full flex border-b-2">
                        <div>
                            <p class="text-gray-600 super-bold text-xl">0{{ i + 1 }}</p>
                        </div>
                        <div class="ms-6">
                            <p class="text-gray-800">{{ item }}</p>
                        </div>
                    </li>
                </ul>
                <ng-container *ngIf="i === 2">
                    <div class="p-6">
                        <p class="text-gray-800 text-sm font-semibold px-6">
                            * Any non-English documentation must have a certified English translation.
                            Admission to the master’s program may be accepted for students returning to school after 5
                            years of documented work experience upon review of prior learning experience. These students
                            may be accepted as non-degree seeking students.
                        </p>
                    </div>
                </ng-container>
                <ng-container *ngIf="i === 3">
                    <div class="p-6">
                        <div class="text-gray-800 text-sm px-6 ">
                            <p class="mb-1 font-semibold text-gray-800">* Any non-English documentation must have a
                                certified English translation.
                            </p>
                            <p>Admission to the doctorate program may be accepted for students who have a master’s
                                degree in another field. These students may be accepted as non-degree seeking students.
                            </p>
                            <p>Applicants to the doctoral program must submit proof of earning a master’s degree in
                                business related topics, transcripts, a resume/cv, and 3 letters of recommendation by
                                faculty, colleagues or employers. Admission to the doctorate program may be accepted for
                                students returning to school after 5 years of documented work experience upon review of
                                prior learning experience. These students may be accepted as non-degree seeking
                                students.
                            </p>
                            <p>If official original transcripts are not sent with the application, the transcripts must
                                be sent prior to:
                            </p>
                            <ul class="my-1">
                                <li>
                                    <p>a. The first 9 semester credit hours for bachelor program
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        b. The first 6 semester credit hours for master program
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        c. The first 8 semester credit hours for doctorate program
                                    </p>
                                </li>
                            </ul>
                            <p class="mt-1 font-semibold text-gray-800">Or else the student may be withdrawn from the
                                program and would need to re-apply for admission.

                            </p>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <app-form class="mt-6"></app-form>
    </div>
</section>
<section class="bg-[#b7d8ef] mt-14 md:mt-24 py-10 ">
    <div class="w-[90%] md:w-[90%] flex justify-center xl:w-[70%] mx-auto pt-6">
        <div class="text-center md:w-[80%]">
            <h2  class="mt-[-100px] sm:mt-[-120px] md:mt-[-130px] text-[50px] sm:text-[80px] lg:text-[100px] mx-auto font-bold">APPLY NOW</h2>
            <p class="md:text-2xl font-semibold md:my-[10px]">Are you ready to take the next step toward your future career?</p>
            <button class="bg-black text-white px-5 py-3 mt-2 md:my-3 md:w-1/3 hover:bg-[#36348E] font-bold">Contact Us</button>
        </div>
    </div>
</section>
